import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {CookieService} from 'ngx-cookie-service';
import {isPlatformBrowser} from '@angular/common';

@Injectable({
  providedIn: 'root'
})
export class UniversalStorageService {
  private isBrowser: boolean;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private cookieService: CookieService
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  setItem(key: string, value: string, expiresInDays: number = 7): void {
    if (this.isBrowser) {
      // Client-side: Use localStorage
      localStorage.setItem(key, value);
    } else {
      // Server-side: Use cookies
      const expires = new Date();
      expires.setDate(expires.getDate() + expiresInDays);
      this.cookieService.set(key, value, expires, '/');
    }
  }

  getItem(key: string): string | null {
    if (this.isBrowser) {
      // Client-side: Use localStorage
      return localStorage.getItem(key);
    } else {
      // Server-side: Use cookies
      return this.cookieService.get(key) || null;
    }
  }

  removeItem(key: string): void {
    if (this.isBrowser) {
      // Client-side: Use localStorage
      localStorage.removeItem(key);
    } else {
      // Server-side: Use cookies
      this.cookieService.delete(key, '/');
    }
  }
}
